'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FaEnvelope = function (_React$Component) {
  _inherits(FaEnvelope, _React$Component);

  function FaEnvelope() {
    _classCallCheck(this, FaEnvelope);

    return _possibleConstructorReturn(this, (FaEnvelope.__proto__ || Object.getPrototypeOf(FaEnvelope)).apply(this, arguments));
  }

  _createClass(FaEnvelope, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M1792 710v794q0 66-47 113t-113 47H160q-66 0-113-47T0 1504V710q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38T639 1015q-91-64-262-182.5T172 690q-62-42-117-115.5T0 438q0-78 41.5-130T160 256h1472q65 0 112.5 47t47.5 113z' })
        )
      );
    }
  }]);

  return FaEnvelope;
}(_react2.default.Component);

FaEnvelope.defaultProps = {
  viewBox: '0 0 1792 1896.0833',
  height: '1em',
  width: '0.9451em'
};

exports.default = FaEnvelope;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/fa/envelope.js
// module id = 562
// module chunks = 0 1 2 3 4 5 6